/**
 * Tiny GA4 + dataLayer analytics helper.
 *
 * Safe to call before/without GA4 loaded — falls back to dataLayer push,
 * and ultimately to a no-op. Events used by Google Ads conversion tracking:
 *
 *   - demo_modal_opened    → fires when "Book a Demo" CTA is clicked
 *   - signup_clicked       → fires when any signup CTA is clicked
 *   - calendly_loaded      → fires when a Calendly widget mounts (future use)
 *
 * Ads conversions can be configured to listen on these GA4 event names.
 */

export function trackEvent(eventName, params = {}) {
  if (!eventName || typeof eventName !== 'string') return;
  try {
    if (typeof window === 'undefined') return;

    // Always push to dataLayer (works for GTM users even without GA4)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });

    // Direct gtag call when GA4 is loaded
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
  } catch {
    /* no-op — analytics must never break user flows */
  }
}

export const Events = {
  DEMO_MODAL_OPENED: 'demo_modal_opened',
  SIGNUP_CLICKED: 'signup_clicked',
  CALENDLY_LOADED: 'calendly_loaded',
  LANDING_CTA_CLICK: 'landing_cta_click',
  TRY_CALL_REQUESTED: 'try_call_requested',
};
